export default __webpack_public_path__ + "static/media/Hendersons - Pre-Contract Info.80eecbd0.31645fde.pdf";